// Catálogo Central de Coroa de Flores RJ

const IMG = (ref) => `/coroas/${ref}.webp`;

// Tamanhos padrão — preço-base corresponde a 1,00m (P). Demais tamanhos com acréscimo.
export const SIZES = [
  { id: "P",  label: "P",  dim: "1,00m", mult: 1.00 },
  { id: "M",  label: "M",  dim: "1,20m", mult: 1.40 },
  { id: "G",  label: "G",  dim: "1,40m", mult: 1.70 },
  { id: "GG", label: "GG", dim: "1,60m", mult: 2.00 },
];

export const DEFAULT_SIZE = "P";

// Preço-base (1,00m) por referência
const BASE_P = {
  "REF-01": 399, "REF-03": 480,
  "REF-04": 990, "REF-05": 1100, "REF-06": 1200, "REF-07": 1200,
  "REF-08": 1250, "REF-09": 1250, "REF-10": 999, "REF-11": 1350,
  "REF-12": 1350, "REF-14": 1100, "REF-15": 1450,
  "REF-16": 1450, "REF-17": 1200, "REF-19": 1550,
  "REF-20": 1780, "REF-21": 2350, "REF-22": 2350,
  "REF-23": 2700, "REF-24": 2700, "REF-25": 2700,
  "REF-26": 2700, "REF-27": 2700, "REF-28": 2700,
};

// Overrides pontuais para preços específicos
const OVERRIDES = {};

const roundTo = (v, step) => Math.round(v / step) * step;
const computeSizes = (ref) => {
  const base = BASE_P[ref];
  const step = base >= 1000 ? 50 : 10;
  const ov = OVERRIDES[ref] || {};
  const out = {};
  for (const s of SIZES) {
    out[s.id] = ov[s.id] ?? (s.mult === 1 ? base : roundTo(base * s.mult, step));
  }
  return out;
};

export const PRODUCTS = [
  { ref: "REF-01", tier: "basic",   description: "Coroa de flores com arranjo central em tons de amarelo e branco." },
  { ref: "REF-03", tier: "basic",   description: "Coroa de flores totalmente branca — simbolismo de paz e serenidade." },
  { ref: "REF-04", tier: "medium",  description: "Coroa com flores brancas, vermelhas e verdes, com faixa de inscrição inclusa." },
  { ref: "REF-05", tier: "medium",  description: "Coroa em tons de rosa e verde com faixa personalizada para homenagem." },
  { ref: "REF-06", tier: "medium",  description: "Coroa em tons de rosa claro, branco e verde — composição suave e elegante." },
  { ref: "REF-07", tier: "medium",  description: "Coroa com arranjo central em flores amarelas e brancas, acabamento refinado." },
  { ref: "REF-08", tier: "premium", description: "Coroa premium com girassóis no centro circundados por flores brancas." },
  { ref: "REF-09", tier: "premium", description: "Coroa premium com mix colorido — rosa, amarelo, branco e folhagens." },
  { ref: "REF-10", tier: "premium", description: "Coroa premium totalmente branca, arranjo denso e exuberante." },
  { ref: "REF-11", tier: "premium", description: "Coroa premium com centro em flores brancas e amarelas, design clássico." },
  { ref: "REF-12", tier: "luxury",  description: "Coroa de luxo com tons creme, rosa e amarelo — composição sofisticada." },
  { ref: "REF-14", tier: "luxury",  description: "Coroa de luxo em creme, rosa e amarelo com faixa personalizada inclusa." },
  { ref: "REF-15", tier: "luxury",  description: "Coroa de luxo em creme, rosa e amarelo com mensagem personalizada na faixa." },
  { ref: "REF-16", tier: "luxury",  description: "Coroa de luxo totalmente branca, arranjo denso e refinado." },
  { ref: "REF-17", tier: "luxury",  description: "Coroa de luxo com arranjo central em flores brancas e amarelas." },
  { ref: "REF-19", tier: "luxury",  description: "Coroa de luxo com flores vermelhas, brancas e amarelas — elegância marcante." },
  { ref: "REF-20", tier: "deluxe",  description: "Coroa deluxe em tons creme e rosa com faixa personalizada de homenagem." },
  { ref: "REF-21", tier: "deluxe",  description: "Coroa deluxe em tons rosa e branco — composição clássica e marcante." },
  { ref: "REF-22", tier: "deluxe",  description: "Coroa deluxe em branco e lilás — composição delicada e imponente." },
  { ref: "REF-23", tier: "deluxe",  description: "Coroa deluxe com girassóis e flores brancas — faixa de homenagem inclusa." },
  { ref: "REF-24", tier: "deluxe",  description: "Coroa deluxe em tons branco e rosa, arranjo central em destaque." },
  { ref: "REF-25", tier: "deluxe",  description: "Coroa deluxe em formato de anel, flores brancas com detalhes verdes e faixa." },
  { ref: "REF-26", tier: "deluxe",  description: "Coroa deluxe em flores brancas e amarelas — composição clássica e marcante." },
  { ref: "REF-27", tier: "deluxe",  description: "Coroa deluxe em formato de coração — rosa, branco e verde com faixa personalizada." },
  { ref: "REF-28", tier: "deluxe",  description: "Coroa deluxe em flores brancas com detalhes verdes e faixa de assinatura." },
].map((p) => ({
  ...p,
  name: `Coroa ${p.ref}`,
  img: IMG(p.ref),
  price: BASE_P[p.ref],
  sizes: computeSizes(p.ref),
}));

export const TIER_LABEL = {
  basic: "Tradicional",
  medium: "Intermediária",
  premium: "Premium",
  luxury: "Luxo",
  deluxe: "Deluxe",
};

export const TIER_GROUPS = [
  { id: "all",     label: "Todas" },
  { id: "basic",   label: "Tradicional" },
  { id: "medium",  label: "Intermediária" },
  { id: "premium", label: "Premium" },
  { id: "luxury",  label: "Luxo" },
  { id: "deluxe",  label: "Deluxe" },
];

export const BRAND = {
  name: "Central de Coroas de Flores",
  shortName: "Central de Coroas",
  fullName: "Central de Coroa de Flores RJ",
  tagline: "Coroas de flores entregues com respeito em todos os cemitérios do município do Rio.",
  phoneE164: "5521966748595",
  phoneDisplay: "(21) 96674-8595",
  city: "Rio de Janeiro · RJ",
  address: "R. Real Grandeza, 450 — Botafogo, Rio de Janeiro/RJ · CEP 22281-030",
  hours: "Atendimento 24h, todos os dias",
  coverage: "Atendemos todos os cemitérios e capelas do município do Rio de Janeiro.",
  social: {
    facebook: "https://www.facebook.com/riodejaneirofloricultura",
    instagram: "https://www.instagram.com/central_de_coroa_de_flores",
    google: "https://www.google.com/search?q=Central+de+coroa+de+Flores+_Coroa+de+flores&stick=H4sIAAAAAAAA_-NgU1I2qLBMSjFNTjExMzRJTUk2tTKoMDUyTrQwSE40TjOyTDVNSl7Equ2cmldSlJijkJKqkJxflJ8IYrjl5BelFivEO8ME0sACAAabxhhVAAAA",
    mapsEmbed: "https://maps.google.com/maps?q=R.+Real+Grandeza,+450+-+Botafogo,+Rio+de+Janeiro,+RJ&t=&z=17&ie=UTF8&iwloc=&output=embed",
    mapsLink: "https://www.google.com/maps/place/R.+Real+Grandeza,+450+-+Botafogo,+Rio+de+Janeiro+-+RJ,+22281-030",
  },
};

export const CEMITERIOS = [
  "Cemitério São João Batista",
  "Cemitério do Caju",
  "Cemitério Memorial do Carmo",
  "Cemitério da Penitência",
  "Crematório do Rio de Janeiro",
  "Cemitério São Francisco Xavier",
  "Cemitério de Inhaúma",
  "Cemitério do Catumbi",
  "Cemitério do Cajueiro",
  "Cemitério de Irajá",
  "Cemitério de Ricardo de Albuquerque",
  "Cemitério de Sulacap",
  "Cemitério Israelita do Caju",
  "Cemitério Comunal Israelita de Inhaúma",
  "Cemitério Parque da Colina",
  "Cemitério Jardim da Saudade (Sulacap)",
];

// Bairros atendidos — Zona Sul, Zona Norte e Centro do Rio de Janeiro
export const ZONA_SUL = [
  "Botafogo",
  "Copacabana",
  "Ipanema",
  "Leblon",
  "Flamengo",
  "Laranjeiras",
  "Urca",
  "Humaitá",
  "Jardim Botânico",
  "Gávea",
  "São Conrado",
  "Leme",
  "Cosme Velho",
  "Catete",
  "Glória",
  "Vidigal",
];

export const ZONA_NORTE = [
  "Tijuca",
  "Méier",
  "São Cristóvão",
  "Vila Isabel",
  "Grajaú",
  "Maracanã",
];

export const CENTRO = [
  "Centro",
  "Lapa",
  "Santa Teresa",
  "Cidade Nova",
  "Saúde",
];
